<template>
<ul class="related-many related-blocks">
  <template v-for="(block, ii) in value" :key="block.uuid || block.rand">
    <li class="new">
      <button class="btn btn-primary" v-on:click.prevent="componentPopup=true; insertIndex=ii"><i :class="'fas fa-plus'"></i></button>
      <div class="page-block-type-list" v-if="componentPopup && insertIndex==ii">
        <button v-for="(type, typeid) in types" class="btn btn-primary" v-on:click.prevent="addNew(typeid)" href="">
          {{ type.label }}
        </button>
      </div>

    </li>
    <li class="related-block related-block-page">
      <button class="btn btn-danger" @click.prevent="removeItem(ii)">
        <i :class="'fas fa-xmark'"></i>
      </button>
      <span class="type">{{ types[block.type]?.label }}</span>
      <div class="gf-row">
        <DataForm :params="{type: componentForType(block.type), dataType: 'PageBlock'}" v-if="value[ii]" v-model:item="value[ii].content" :key="'block-'+(block.dataid || block.id)"></DataForm>
      </div>
    </li>
  </template>
  <li class="new">
    <button class="btn btn-primary" v-on:click.prevent="componentPopup=true; insertIndex=-1"><i :class="'fas fa-plus'"></i></button>
    <div class="page-block-type-list" v-if="componentPopup && insertIndex==-1">
      <button v-for="(type, typeid) in types" class="btn btn-primary" v-on:click.prevent="addNew(typeid)" href="">
        {{ type.label }}
      </button>
    </div>
  </li>
</ul>
<!--<Popup v-model="componentPopup">
</Popup>-->
</template>

<script>
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    componentPopup: false,
    insertIndex: null,
    value: [],
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=(this.modelValue || []).slice();
        this.value.sort((a,b)=>(a.orderindex || 0)-(b.orderindex || 0));
      }, immediate: true,
    },
  },
  computed: {
    dataConfig() {
      return this.stores.config.config?.data;
    },
    types() {
      var result={};
      for(var type in this.dataConfig || {}) {
        if (this.dataConfig[type].pageBlockTitle)
          result[this.typeForType(type)]={label: this.dataConfig[type].pageBlockTitle};
      }
      return result
    },
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    typeForType(type) {
      type=String(type).replace(/^PageBlock/, "");
      type=type.substring(0,1).toLowerCase()+type.substring(1);
      return type;
    },
    componentForType(type) {
      type=String(type);
      return "PageBlock"+(type.substring(0,1).toUpperCase())+type.substring(1);
    },
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew(typeid) {
      this.componentPopup=false;

      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
      }
      newItem.dataid=Math.random().toString().substring(2);
      if (typeid) {
        newItem.type=typeid;
        newItem.content=this.types[typeid].content || {tempField: ""};
        newItem.rand=Math.random().toString().substring(2);
      }
      if (this.insertIndex==-1)
        this.value.push(newItem);
      else
        this.value.splice(this.insertIndex, 0, newItem);
      for(var bi in this.value) {
        this.value[bi].orderindex=bi;
      }

    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
  },
}
</script>
